import React from 'react';
import { Star } from 'lucide-react';

interface StarRatingProps {
  rating: number;
  maxRating?: number;
  reviewCount?: number;
  showScore?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export const StarRating: React.FC<StarRatingProps> = ({
  rating,
  maxRating = 5,
  reviewCount,
  showScore = true,
  size = 'sm',
}) => {
  const iconSizes = {
    sm: 'w-3.5 h-3.5',
    md: 'w-4 h-4',
    lg: 'w-5 h-5',
  };

  const textSizes = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base',
  };

  return (
    <div className="flex items-center gap-1.5" aria-label={`Rating: ${rating} out of ${maxRating}`}>
      <div className="flex items-center text-amber-400">
        {Array.from({ length: maxRating }).map((_, index) => {
          const filled = index + 1 <= Math.floor(rating);
          const half = !filled && index < rating;
          return (
            <Star
              key={index}
              className={`${iconSizes[size]} ${
                filled
                  ? 'fill-amber-400 text-amber-400'
                  : half
                  ? 'fill-amber-300 text-amber-400'
                  : 'text-slate-300 fill-slate-100'
              }`}
            />
          );
        })}
      </div>

      {showScore && (
        <span className={`font-bold text-[#172554] ${textSizes[size]}`}>
          {rating.toFixed(1)}
        </span>
      )}

      {typeof reviewCount === 'number' && (
        <span className={`text-[#64748B] font-normal ${textSizes[size]}`}>
          ({reviewCount})
        </span>
      )}
    </div>
  );
};
